module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer",
    class: {
      none: _vm.isHide
    }
  }, [_c('footer', [_c('div', {
    staticClass: "footer-container"
  }, [_c('ul', [_c('li', {
    class: {
      current: _vm.menuType1Selected
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [(_vm.menuType1Selected) ? _c('div', {
    staticClass: "tab-img"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/footicon1.0.png")
    }
  }), _c('span', {
    staticClass: "tab-title"
  }, [_vm._v("预约")])]) : _c('div', {
    staticClass: "tab-img"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/footicon1.png")
    }
  }), _c('span', {
    staticClass: "tab-title"
  }, [_vm._v("预约")])])])], 1), _vm._v(" "), _c('li', {
    class: {
      current: _vm.menuType2Selected
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/topic"
    }
  }, [(_vm.menuType2Selected) ? _c('div', {
    staticClass: "tab-img"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/footicon2.0.png")
    }
  }), _c('span', {
    staticClass: "tab-title"
  }, [_vm._v("话题")])]) : _c('div', {
    staticClass: "tab-img"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/footicon2.png")
    }
  }), _c('span', {
    staticClass: "tab-title"
  }, [_vm._v("话题")])])])], 1), _vm._v(" "), _c('li', {
    class: {
      current: _vm.menuType3Selected
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/my"
    }
  }, [(_vm.menuType3Selected) ? _c('div', {
    staticClass: "tab-img"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/footicon3.0.png")
    }
  }), _c('span', {
    staticClass: "tab-title"
  }, [_vm._v("我的")])]) : _c('div', {
    staticClass: "tab-img"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/footicon3.png")
    }
  }), _c('span', {
    staticClass: "tab-title"
  }, [_vm._v("我的")])])])], 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-ce818388"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Footer.vue
// module id = 203
// module chunks = 1